function initCardFlip() {
  const cards = document.querySelectorAll('.pagefx-card-flip');
  if (!cards.length) return;

  function frontFlip(triggerElement, cardFrontElement, cardBackElement) {
    cardFrontElement.parentElement.classList.remove('flipped');
    triggerElement.setAttribute('aria-expanded', false);
    triggerElement.classList.remove('flipped');
    cardFrontElement.classList.remove('flipped');
    cardBackElement.classList.remove('flipped');

    const frontText = triggerElement.getAttribute('data-front-text');
    if (frontText !== '') {
      const triggerTextElement = triggerElement.firstElementChild;
      if (triggerTextElement) {
        triggerTextElement.innerHTML = frontText;
      } else {
        triggerElement.innerText = frontText;
      }
    }
  }

  function backFlip(triggerElement, cardFrontElement, cardBackElement) {
    cardFrontElement.parentElement.classList.add('flipped');
    triggerElement.setAttribute('aria-expanded', true);
    triggerElement.classList.add('flipped');
    cardFrontElement.classList.add('flipped');
    cardBackElement.classList.add('flipped');

    const backText = triggerElement.getAttribute('data-back-text');
    if (backText !== '') {
      const triggerTextElement = triggerElement.firstElementChild;
      if (triggerTextElement) {
        triggerTextElement.innerHTML = backText;
      } else {
        triggerElement.innerText = backText;
      }
    }
  }

  function toggleCard(trigger, front, back) {
    if (trigger.classList.contains('flipped')) {
      frontFlip(trigger, front, back);
    } else {
      backFlip(trigger, front, back);
    }
  }

  function initializeCard(element, index) {
    const triggerElement = element.querySelector('.pagefx-card__trigger');
    const cardFrontElement = element.querySelector('.pagefx-card__front');
    const cardBackElement = element.querySelector('.pagefx-card__back');

    if (!triggerElement || !cardFrontElement || !cardBackElement) {
      throw new Error('Card element must contain a trigger, front, and back element to flip');
    }

    cardFrontElement.id = cardFrontElement.id || `pagefx_card_front_${index}`;
    cardBackElement.id = cardBackElement.id || `pagefx_card_back_${index}`;
    triggerElement.id = triggerElement.id || `pagefx_card_trigger_${index}`;

    if (!triggerElement.getAttribute('aria-controls')) {
      triggerElement.setAttribute('aria-controls', cardBackElement.id);
    }

    if (!triggerElement.getAttribute('aria-expanded')) {
      triggerElement.setAttribute('aria-expanded', 'false');
    }

    if (!cardBackElement.getAttribute('aria-labelledby')) {
      cardBackElement.setAttribute('aria-labelledby', triggerElement.id);
    }

    triggerElement.addEventListener('click', () => {
      toggleCard(triggerElement, cardFrontElement, cardBackElement);
    });
  }

  cards.forEach((card, index) => {
    initializeCard(card, index);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCardFlip();
  ScrollSmoother.refresh();
}, false);
